export default __webpack_public_path__ + "locales/ar-SA/Profile.json?hash=11a71d0967544c9742d5f6b2caeec094";